import React, { Component } from 'react'
import { Form, Select } from 'antd'
import { SpecieProvider, SpecieConsumer } from '../../../../context/SpecieContext'

export default class MappingSpecieForm extends Component {
  render() {
    return (
      <SpecieProvider>
        <SpecieConsumer>
          {({ fetching, species, requestSpecieList }) => {
            if (!fetching && !species) {
              setTimeout(() => {
                requestSpecieList({
                  options: {
                    limit: 9999,
                    sort: ['name']
                  }
                })
              }, 50)
            }

            const speciesOptions = species?.map(specie => {
              return {
                label: specie.name,
                value: specie.uuid
              }
            }) as any

            return (
              <Form.Item
                label="Species"
                name="specie_uuid"
                rules={[
                  {
                    required: true,
                    message: 'Missing a species'
                  }
                ]}
              >
                <Select
                  loading={fetching}
                  placeholder="Select a species"
                  options={speciesOptions}
                />
              </Form.Item>
            ) 
          }}
        </SpecieConsumer>
      </SpecieProvider>
    )
  }
}
